
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import React from "react";

export default function MyLoader() {
  return (
    <div className="w-full   h-screen flex items-center justify-center">
      <DotLottieReact
        className=" w-[35vw] h-[35vw]
          sm:w-[28vw] sm:h-[28vw]
          md:w-[20vw] md:h-[20vw]
          lg:w-[14vw] lg:h-[14vw]
          xl:w-[10vw] xl:h-[10vw]
           w-full
          "
        src="https://lottie.host/3ba84a2d-bfb0-4c3e-9d07-74b288d973e2/hbsrnUx38D.lottie"
        loop
        autoplay
      />
    </div>
  );
}
